import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { formRules } from "@/js/form_rules.js";
import moment from "moment";
import { USER_GROUPS, USER_GROUPS_ARRAY } from "@/js/maintenance/constants";
export default {
  name: "ScheduledMaintenanceModal",
  data: function data() {
    return {
      options: {
        color: "primary",
        zIndex: 2000
      },
      shown: false,
      startTime: null,
      startDate: moment().format("YYYY-MM-DD"),
      menuStartDate: false,
      calculatedEndDateTime: null,
      duration: null,
      durationUnit: "minutes",
      durationUnits: [{
        id: "minutes",
        label: "Minutes"
      }, {
        id: "hours",
        label: "Hours"
      }],
      description: "",
      onGoingDescription: "",
      alertThresholdMinutes: 60,
      selectedUserGroups: [],
      quickUserGroups: [],
      UserGroupsConfigHeader: [{
        text: "User group",
        value: "name"
      }, {
        text: "Can work",
        value: "canwork"
      }, {
        text: "Custom description (defaults to main description if left empty)",
        value: "custom-description",
        cellClass: "custom-description"
      }],
      userGroupCanWorkCheckboxes: {},
      userGroupCustomDescriptions: {
        adminNotConsultant: "We're currently performing minor updates in the background. " + "You can continue working, but some actions may temporarily fail. " + "If that happens, just wait a minute and try again. " + "To avoid issues, please refrain from running heavy tasks like 'Export Price List' during this time."
      },
      quickDescriptions: [{
        id: 1,
        title: "Performance",
        description: "We will be performing routine system maintenance to enhance performance and reliability. During this time, services will be temporarily unavailable."
      }, {
        id: 2,
        title: "Security",
        description: "Scheduled maintenance will be carried out to implement important security updates and improvements. Brief service interruptions will occur."
      }, {
        id: 3,
        title: "Infrastructure",
        description: "Our team will conduct necessary infrastructure upgrades to ensure optimal service quality. Services will be inaccessible during this period."
      }, {
        id: 4,
        title: "Optimization",
        description: "We're optimizing our systems to better serve you. This planned maintenance will result in short-term service disruptions."
      }],
      formRules: formRules,
      USER_GROUPS: USER_GROUPS,
      USER_GROUPS_ARRAY: USER_GROUPS_ARRAY
    };
  },
  computed: {
    isFormValid: function isFormValid() {
      var startDateTime = moment("".concat(this.startDate, " ").concat(this.startTime), "YYYY-MM-DD HH:mm");
      var endDateTime = this.calculatedEndDateTime;
      return this.startDate && this.startTime && this.duration && this.durationUnit && this.formRules.mustNotBeEmpty(this.startDate) === true && this.formRules.mustBeDate(this.startDate) === true && this.formRules.mustNotBeEmpty(this.startTime) === true && this.formRules.mustBeTime(this.startTime) === true && this.duration > 0 && ["minutes", "hours"].includes(this.durationUnit) && endDateTime && endDateTime.isValid() && endDateTime.isSameOrAfter(startDateTime);
    },
    formattedEndDateTime: function formattedEndDateTime() {
      return this.calculatedEndDateTime ? moment(this.calculatedEndDateTime).format("LLL") : null;
    }
  },
  watch: {
    startDate: "calculateEndDateTime",
    startTime: "calculateEndDateTime",
    duration: "calculateEndDateTime",
    durationUnit: "calculateEndDateTime",
    selectedUserGroups: {
      immediate: true,
      handler: function handler(groups) {
        var _this = this;
        this.userGroupCanWorkCheckboxes = {};
        this.userGroupCustomDescriptions = {};
        groups.forEach(function (group) {
          var key = group.value;
          var isAdmin = group.name === "AdminNotConsultant";
          _this.$set(_this.userGroupCanWorkCheckboxes, key, isAdmin);
          if (isAdmin) {
            _this.$set(_this.userGroupCustomDescriptions, key, "We're currently performing minor updates in the background. You can continue working, but some actions may temporarily fail. If that happens, just wait a minute and try again. To avoid issues, please refrain from running heavy tasks like 'Export Price List' during this time.");
          }
        });
      }
    }
  },
  created: function created() {
    this.initUserGroups();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.resetForm();
    },
    resetForm: function resetForm() {
      this.startTime = null;
      this.startDate = moment().format("YYYY-MM-DD");
      this.menuStartDate = false;
      this.calculatedEndDateTime = null;
      this.duration = null;
      this.durationUnit = "minutes";
      this.durationUnits = [{
        id: "minutes",
        label: "Minutes"
      }, {
        id: "hours",
        label: "Hours"
      }];
      this.description = "";
      this.alertThresholdMinutes = 60;
      this.userGroupCanWorkCheckboxes = {};
      this.userGroupCustomDescriptions = {};
    },
    setStartQuickTime: function setStartQuickTime(minutes) {
      var now = moment();
      var start = now.add(minutes, "minutes");
      this.startTime = start.format("HH:mm");
    },
    setDurationQuickTime: function setDurationQuickTime(value) {
      this.duration = value;
    },
    setQuickDescription: function setQuickDescription(id) {
      this.description = this.getQuickDescription(id);
    },
    getQuickDescription: function getQuickDescription(id) {
      return this.quickDescriptions.find(function (x) {
        return x.id === id;
      }).description;
    },
    getQuickDescriptionTitle: function getQuickDescriptionTitle(id) {
      return this.quickDescriptions.find(function (x) {
        return x.id === id;
      }).title;
    },
    getQuickUserGroups: function getQuickUserGroups(id) {
      return this.quickUserGroups.find(function (x) {
        return x.id === id;
      }).userGroups;
    },
    setQuickUserGroups: function setQuickUserGroups(id) {
      this.selectedUserGroups = null;
      this.selectedUserGroups = this.getQuickUserGroups(id);
    },
    getQuickUserGroupsName: function getQuickUserGroupsName(id) {
      return this.quickUserGroups.find(function (x) {
        return x.id === id;
      }).name;
    },
    findUserGroup: function findUserGroup(id) {
      return USER_GROUPS_ARRAY.find(function (x) {
        return x.id == id;
      });
    },
    calculateEndDateTime: function calculateEndDateTime() {
      if (this.startDate && this.startTime && this.duration && this.durationUnit) {
        var startDateTime = moment("".concat(this.startDate, " ").concat(this.startTime), "YYYY-MM-DD HH:mm");
        this.calculatedEndDateTime = startDateTime.clone().add(this.duration, this.durationUnit);
      } else {
        this.calculatedEndDateTime = null;
      }
    },
    initUserGroups: function initUserGroups() {
      this.selectedUserGroups = [this.USER_GROUPS.adminNotConsultant, this.USER_GROUPS.consultantOrHolding, this.USER_GROUPS.individual, this.USER_GROUPS.professional, this.USER_GROUPS.wholesaler];
      this.quickUserGroups = [{
        id: 1,
        name: "Everyone",
        userGroups: [this.USER_GROUPS.adminNotConsultant, this.USER_GROUPS.consultantOrHolding, this.USER_GROUPS.individual, this.USER_GROUPS.professional, this.USER_GROUPS.wholesaler]
      }, {
        id: 2,
        name: "Only Users",
        userGroups: [this.USER_GROUPS.consultantOrHolding, this.USER_GROUPS.individual, this.USER_GROUPS.professional, this.USER_GROUPS.wholesaler]
      }, {
        id: 3,
        name: "Only AdminNotConsultant",
        userGroups: [this.USER_GROUPS.adminNotConsultant]
      }];
    },
    submitForm: function submitForm() {
      var _this2 = this;
      if (!this.isFormValid) {
        console.error("Form is not valid");
        return;
      }
      var startDateTime = moment("".concat(this.startDate, " ").concat(this.startTime), "YYYY-MM-DD HH:mm");
      var endDateTime = this.calculatedEndDateTime;
      var maintenanceData = {
        startDateTime: startDateTime.format("YYYY-MM-DDTHH:mm:00Z"),
        endDateTime: endDateTime.format("YYYY-MM-DDTHH:mm:00Z"),
        duration: this.duration,
        durationUnit: this.durationUnit,
        description: this.description,
        alertThresholdMinutes: this.alertThresholdMinutes
      };
      var targetGroups = this.USER_GROUPS_ARRAY.map(function (group) {
        return {
          user_group_id: group.id,
          can_work: !!_this2.userGroupCanWorkCheckboxes[group.value],
          custom_description: _this2.userGroupCustomDescriptions[group.value] || null
        };
      });
      try {
        this.$maintenanceMode.addScheduledMaintenance(maintenanceData.startDateTime, maintenanceData.endDateTime, maintenanceData.description, maintenanceData.alertThresholdMinutes, targetGroups);
        this.$emit("maintenance-scheduled", maintenanceData);
        this.$emit("closed");
        this.close();
      } catch (error) {
        console.log("Error scheduling maintenance:", error);
      }
    }
  }
};